import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import type { ReviewErrorViewModel } from "../api/errors";

/**
 * On TOKEN_EXPIRED, clear the local session once and return to the public
 * home (`/`) so consultation remains usable without a forced login wall.
 * Private actions stay gated; the header Login link remains available.
 */
export function useSessionExpiryRedirect(error: ReviewErrorViewModel | null): void {
  const auth = useAuth();
  const navigate = useNavigate();
  const handledRef = useRef(false);

  useEffect(() => {
    if (error?.code !== "TOKEN_EXPIRED" || handledRef.current) return;
    handledRef.current = true;
    auth.logout();
    void navigate("/", { replace: true });
  }, [error, auth, navigate]);
}
